import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IconButton } from "../../../components/buttons";
import * as actions from "../../../actions/index";
import { Popup } from "../../../components/pop-up";
import { TextBox } from "../../../components/inputs";


import { module_plans } from "../../../util/master-data";
import { toast } from "react-toastify";
export function ModuleDetails({
  modules,
  onChange,
  readOnly,
  showPlans = true,
  moduleWithCount,
  company_uid
}) {
  const dispatch = useDispatch();
  const allModulesList = useSelector((state) => state.company.allModules);
  const [plans, setPlans] = useState([]);
  const [openModal, setOpenModal] = useState();
  const [moduleStartCount, SetModuleStartCount] = useState({ "module_name": "", "module": "", "moduleCount": "","currentModuleCount":0 });

  useEffect(() => {
    dispatch(actions.GETALLMODULES_REQ({}));
  }, []);

  useEffect(() => {
    if (allModulesList?.length > 0) {
      setPlans(
        JSON.parse(JSON.stringify(module_plans)).map((plan) => {
          plan.modules = plan.modules.map(
            (module_key) =>
              allModulesList.filter((m) => m.module_key === module_key)[0]
                ?.module_uid
          ).filter((_m) => _m);
          return plan;
        })
      );
    }
  }, [allModulesList]);

  // const { modules, setModules, plan, setPlan } = hook;
  useEffect(() => {
    let [currentPlan] = plans?.filter(
      (_plan) =>
        _plan.modules.length === modules.length &&
        _plan.modules.every((_module) => modules.includes(_module))
    );
    setPlan(currentPlan || { name: "", modules: [] });
  }, [plans, modules]);

  const [plan, setPlan] = useState();

  return (
    <>
      <div className="relative p-3">
        {/* {readOnly && (
          <div className="absolute w-full h-full z-30 top-0 left-0"></div>
        )} */}
        <fieldset className="grid grid-cols-3 gap-4 w-full mb-5">
          {showPlans &&
            plans &&
            plans.map((_plan) => (
              <div>
                <input
                  type="checkbox"
                  name="Plans"
                  value={_plan.name}
                  id={_plan.name}
                  onChange={() => {
                    if (!readOnly) {
                      if (_plan.name === plan?.name) {
                        onChange([]);
                        // setPlan({ name: "", modules: [] });
                      } else {
                        onChange([..._plan.modules]);
                        // setPlan(_plan);
                      }
                    }
                  }}
                  checked={_plan.name === plan?.name}
                  className="peer hidden [&:checked_+_label_svg]:block"
                />

                <label
                  htmlFor={_plan.name}
                  className="block shadow-md cursor-pointer rounded-lg border border-gray-100 bg-white p-4 text-md font-medium  hover:border-gray-200 peer-checked:border-gray-700 peer-checked:ring-1 peer-checked:ring-gray-500"
                >
                  <div className="flex items-center justify-between">
                    <p className="text-gray-700">{_plan.name}</p>

                    <svg
                      className="hidden h-5 w-5 text-gray-700"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                </label>
              </div>
            ))}
        </fieldset>
        <div className="mt-10 grid grid-cols-3 gap-6 ">
          {allModulesList?.map((m) => (
            // <ToggleSwitch
            //   key={m.module_uid}
            //   className="disabled:cursor-pointer disabled:checked:text-gray-700"
            //   checked={modules.includes(m.module_uid)}
            // onChange={(val) => {
            //   if (!readOnly) {
            //     modules.splice(
            //       modules.indexOf(m.module_uid),
            //       ...(val ? [0, m.module_uid] : [1])
            //     );
            //     onChange([...modules]);
            //   }
            // }}
            //   label={m.module_name}
            // />
            <div >
              <label className={`relative inline-flex items-center ${!readOnly ? 'cursor-pointer' : ''}`}>
                <input
                  key={m.module_uid}
                  type="checkbox"
                  checked={modules.includes(m.module_uid)}
                  onChange={(e) => {
                    let val = e.target.checked;
                    if (!readOnly) {
                      modules.splice(
                        modules.indexOf(m.module_uid),
                        ...(val ? [0, m.module_uid] : [1])
                      );
                      onChange([...modules]);
                    }
                  }}
                  className="sr-only peer"
                />
                <div className={`w-11 h-6 bg-gray-200 peer-focus:outline-none ${!readOnly ? "peer-focus:ring-4 peer-focus:ring-gray-300 dark:peer-focus:ring-gray-800" : ""} rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#293341]`}></div>
                <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">

                  {m.module_name}
                </span>
              </label>
              {company_uid && moduleWithCount && (moduleWithCount[m.module_key] >= 0) && <IconButton
                size="xs"
                className="ml-2"
                onClick={() => {
                  SetModuleStartCount({ "module_name": m.module_name, "module": m.module_key, "moduleCount": moduleWithCount[m.module_key], "company_uid": company_uid ,"currentModuleCount":Number(moduleWithCount[m.module_key])})
                  setOpenModal("pop-up")
                }}
              >
                <svg class="w-4 h-4 text-gray-800 dark:text-white" stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M3 10l2 -2v8"></path><path d="M9 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"></path><path d="M17 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5"></path></svg>
              </IconButton>
              }
            </div>
          ))}
        </div>
      </div>

      <Popup
        header={`Update ${moduleStartCount.module_name} Sequence Number`}
        content={
          <>
            <TextBox
              className="text-left mb-5"
              placeholder="100"
              required
              type="number"
              value={moduleStartCount.moduleCount}
              onChange={(e) => {
                moduleStartCount.moduleCount = e.target.value
                SetModuleStartCount({ ...moduleStartCount })
              }}
            />
          </>
        }
        modalState={[openModal, setOpenModal]}
        onConfirm={() => {
          if(moduleStartCount.currentModuleCount >= moduleStartCount.moduleCount){
            toast("Please enter a value greater than the current value", {
              type: "error",
            });
          }else{
            dispatch(actions.SETMODULECOUNT_REQ({
              "module_name": moduleStartCount.module,
              "module_number": moduleStartCount.moduleCount,
              "company_uid": moduleStartCount.company_uid
            }));
            setOpenModal()
          }
        }}
      />
    </>


  );
}
